export default "__VITE_ASSET__DSdqcAP3__"